<div>
  <div class="breadcrumb-block">
    <FlashMessage></FlashMessage>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name:'business-dashboard'}">Home</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Manage users</li>
      </ol>
    </nav>
  </div>
  <div class="manage-package-block">
    <div class="white-box">
      <div class="error-list" v-if="errorsMessage">
        <ul class="error-msg">
          <li v-for="(error,x) in errorsMessage" :key="x">
            <div v-for="(err,i) in error" :key="i">
              <p> {{err}}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="table-title pb-0">
        <div class="row align-items-center">
          <div class="col-lg-6">
            <h5>Manage users</h5>
            <p>To manage users and their role.</p>
          </div>
          <div class="col-lg-6 text-lg-right">
            <a v-if="permission.invitation_add" class="btn add-btn d-inline-block" href="invite-user.php" role="button"
              @click.prevent="redirectToInvite"><i class="fas fa-user"></i> Invite user</a>

            <a v-if="permission.invitation_listPending" class="btn add-btn d-inline-block ml-3" href="pending.php"
              role="button" @click.prevent="redirectToPendingList"><i class="fas fa-hourglass-half"></i> View pending
              invitation</a>
          </div>
        </div>
      </div>
      <hr>
      <div class="manage-user-block">
        <!-- <div class="form-modified">
          <form action="">
            <div class="form-group row">
              <div class="col">
                <input
                  type="text"
                  class="form-control"
                  id="inputPassword"
                  placeholder="Search by username"
                  v-model="SearchBy.Username"
                  @keyup="searchUser()"
                />
              </div>

              <div class="col">
                <input
                  type="text"
                  class="form-control"
                  id="inputPassword"
                  placeholder="Search by email"
                  v-model="SearchBy.Email"
                  @keyup="searchUser()"
                />
              </div>

              <div class="col">
                <div class="multiselect-input">
                  <multiselect :options='StatusList' label="name" :track-by="'id'" v-model="SearchBy.Status"
                    @input="searchUser()" placeholder="Search by status"></multiselect>
                </div>
              </div>
            </div>
          </form>
        </div> -->

        <div class="content-block">
          <div class="table-container">
            <div class="table-responsive">
              <table class="table" id="example">
                <thead class="table-light-bg">
                  <tr>
                    <th scope="col">Username</th>
                    <th scope="col">
                      Email <i class="fas fa-chevron-down"></i>
                    </th>
                    <th scope="col">
                      <div class="text-center">
                        Role <i class="fas fa-chevron-down"></i>
                      </div>
                    </th>
                    <th scope="col">
                      <div class="text-center">
                        Status <span>($)</span>
                        <i class="fas fa-chevron-down"></i>
                      </div>
                    </th>

                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody v-if="UsersList && UsersList.length">
                  <tr v-for="(user, user_index) in UsersList" :key="user_index">
                    <td v-if="">
                      {{user.full_name}}
                    </td>
                    <!-- <td>{{user}}</td> -->
                    <td v-if="user.email">{{user.email}}</td>
                    <td>
                      <div class="text-center"><span class="badge badge-primary">{{user.user_type}}</span></div>
                    </td>
                    <td>
                      <div class="status-icon" v-if="user.status === 1">
                        <i class="fas fa-check-circle"></i>
                      </div>
                      <div v-else class="status-icon">
                        <i class="fas fa-times-circle"></i>
                      </div>
                    </td>
                    <td>
                      <div class="inline-button-block">
                        <a v-if="user.status === 0 && permission.user_activate" class="btn default-btn green" href="#"
                          role="button" data-toggle="modal" data-target="#changeRole"
                          @click.prevent="activateUser(user, user_index)">
                          <i class="fas fa-user-circle"></i> Enale
                        </a>
                        <a v-if="user.status != 0 && permission.user_deactivate" class="btn default-btn red" href="#"
                          role="button" data-toggle="modal" data-target="#disableUser"
                          @click.prevent="deavtiveUser(user, user_index)">
                          <i class="fas fa-times-circle"></i> Disable
                        </a>
                      </div>
                      <!-- <div class="inline-button-block">
                        <a
                          v-if="user.status === 0"
                          class="btn default-btn green"
                          href="#"
                          role="button"
                          data-toggle="modal"
                          data-target="#changeRole"
                          :class="{disabled: Disable.Enable}"
                          @click.prevent="activateUser(user, user_index)"
                        >
                          <i class="fas fa-user-circle"></i> Enable
                        </a>
                        <a
                          v-else
                          class="btn default-btn red"
                          href="#"
                          role="button"
                          data-toggle="modal"
                          data-target="#disableUser"
                          :class="{disabled: Disable.Disable}"
                          @click.prevent="deavtiveUser(user, user_index)"
                        >
                          <i class="fas fa-times-circle"></i> Disable
                        </a>
                      </div> -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <hr>
          <Pager @onPaging="onPaging" :pager="paging"></Pager>
        </div>
      </div>
    </div>
    <!-- Login option box -->
    <!-- <div class="white-box choose-ac mt-4">
      <div class="row align-items-center">
        <div class="col-lg-8">
            <div class="table-title pb-1">
                <h5>Choose an account</h5>
                
              </div>
        </div>
        <div class="col-lg-4">
            <a href="#" class="text-muted">Sign out</a>
        </div>
      </div>
      <hr>
      <div class="account-list">
        <div class="account-list-item">
          <a href="#"></a>
          <div class="img-wrap">
            <img src="https://dummyimage.com/70x70/ddd/333&text=DP" alt="">
          </div>
          <div class="account-name">
            <p>Abhishek KC</p>
            <span>user01@gmail.com</span>
          </div>
        </div>
        <div class="account-list-item">
            <a href="#"></a>
            <div class="img-wrap">
              <img src="https://dummyimage.com/70x70/eee/333&text=DP" alt="">
            </div>
            <div class="account-name">
              <p>Sangam Uprety</p>
              <span>user01@gmail.com</span>
            </div>
          </div>
      </div>
    </div> -->
  </div>
</div>